export function ImageMapBoxConstructor(services) {
  const joint = services.joint;

  return joint.shapes.html.AbstractBoxWithInPort.extend({
    defaults: joint.util.deepSupplement(
      {
        labelText: services.$translate.instant('parameters/quick_replies/details/graph/line_image_map/box_name_in_diagram'),
        labelFill: '#3977e4',
        type: 'html.ImageMapBox',
      },
      joint.shapes.html.AbstractBoxWithInPort.prototype.defaults,
    ),
  });
}
